import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../services/userService/user.service'
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-addtask',
  templateUrl: './addtask.component.html',
  styleUrls: ['./addtask.component.css']
})
export class AddtaskComponent implements OnInit {
  permission: any;
  userRId: any;
  disableDate() {
    return false;
  }
  maxEndDate: Date;
  maxStartDate: Date;
  activitytype: any = 'activity';
  registerForm: FormGroup;
  dropdownTaskTitile: any = {}
  dropdownProject: any = {}
  dropdownTaskStatus: any = {}
  dropdownTaskPriority: any = {}
  dropdownAssignedTo: any = {}
  dropdownInquiry: any = {}
  dropdownTaskTitile2: any = {}
  dropdownTaskFollowers2: any = {}
  dropdownTaskStatus2: any = {}
  dropdownTaskPriority2: any = {}
  dropdownAssignedTo2: any = {}
  invaliddate: boolean;
  selectedInquiry: any = []
  dropdownTaskFollowers: any = {}
  TaskTitileArray: any = []
  ProjectArray: any = []
  TaskStatusArray: any = []
  TaskPriorityArray: any = []
  AssignedToArray: any = []
  TaskFollowersArray: any = []
  submitted = false;
  modalRef: any;
  dropdownList4 = [];
  selectedItems4 = [];
  dropdownSettings4 = {};

  dropdownList5 = [];
  selectedItems5 = [];
  dropdownSettings5 = {};
  productGroup: any = [];
  ProjectAuto = [];
  projectname: any;
  selectedstatusNameId: any;
  selectedstatus1NameId: string;
  Generaltask: FormGroup;
  Start_Date: string;
  End_Date: string;
  Start_Date2: string;
  End_Date2: string;
  popup: boolean = false;
  maxlength: string | number | null
  constructor(
    private formBuilder: FormBuilder,
    private UserService: UserService,
    private router: Router,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
  ) { }
  ngOnInit(): void {
    let permi = JSON.parse(localStorage.getItem('Permission'));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem('roleId');
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.Task_Add != 1 && this.userRId != 1) {
      this.toastr.error('You do not have permission');
      this.router.navigate(['/profile']);
    }

    this.registerForm = this.formBuilder.group({
      Project_Name: ['', Validators.required],
      Inquiry_Name: ['', Validators.required],
      Task_itile: ['', Validators.required],
      Task_Status: ['', Validators.required],
      Start_Date: ['', Validators.required],
      End_Date: ['', Validators.required],
      Assigned_To: ['', Validators.required],
      Task_Followers: [''],
      Task_Priority: ['', Validators.required],
      Task_Description: ['', Validators.required],
      Remark_: [''],
      ActionTaken_: [''],
      OutcomeRemark_: [''],
    })

    this.Generaltask = this.formBuilder.group({

      Task_itile2: ['', Validators.required],
      Task_Status2: ['', Validators.required],
      Start_Date2: ['', Validators.required],
      End_Date2: ['', Validators.required],
      Assigned_To2: ['', Validators.required],
      Task_Followers2: [''],
      Task_Priority2: ['', Validators.required],
      Task_Description2: ['', Validators.required],
      Remark_2: [''],
      ActionTaken_2: [''],
      OutcomeRemark_2: [''],
    })

    this.taskTitle();
    this.TaskStatus();
    this.TaskPriority();
    this.AssignedTo();
    this.TaskFollowers();
    this.Project();
    this.InquiryID();

    this.dropdownTaskTitile = {
      singleSelection: false,
      text: 'Task Titile',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'custom-class',
      badgeShowLimit: 1,
    };
    this.dropdownTaskStatus = {
      singleSelection: true,
      text: 'Task Status',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'custom-class',
    };
    this.dropdownTaskPriority = {
      singleSelection: true,
      text: 'Task Priority',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'custom-class',
    };
    this.dropdownAssignedTo = {
      singleSelection: true,
      text: 'Assigned To',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'custom-class',
    };
    this.dropdownTaskFollowers = {
      singleSelection: false,
      text: 'Task Followers',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'custom-class',
      badgeShowLimit: 1,
    };
    this.dropdownProject = {
      singleSelection: true,
      text: 'Project',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'custom-class',
    };
    this.dropdownInquiry = {
      singleSelection: true,
      text: 'Inquiry ',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'custom-class',
    }

    this.activitytype = 'activity';
    this.taskTitle2();
    this.TaskStatus2();
    this.TaskPriority2();
    this.AssignedTo2();
    this.TaskFollowers2();

    this.dropdownTaskTitile2 = {
      singleSelection: false,
      text: 'Task Titile',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'custom-class',
      badgeShowLimit: 1,
    };
    this.dropdownTaskStatus2 = {
      singleSelection: true,
      text: 'Task Status',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'custom-class',
    };
    this.dropdownTaskPriority2 = {
      singleSelection: true,
      text: 'Task Priority',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'custom-class',
    };
    this.dropdownAssignedTo2 = {
      singleSelection: true,
      text: 'Assigned To',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'custom-class',
    };
    this.dropdownTaskFollowers2 = {
      singleSelection: false,
      text: 'Task Followers',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'custom-class',
      badgeShowLimit: 1,
    };
  }

  TaskTitile1: any = []
  taskTitle() {
    let data = {}
    this.UserService.TaskTitle(data).subscribe(res => {

      if (res['result'] == 'success') {
        this.TaskTitileArray = res
        for (const data of this.TaskTitileArray['Data']) {
          this.TaskTitile1.push({
            id: data['TaskTitleId'],
            itemName: data['Name']
          })
        }
      } else {
        this.TaskTitileArray = []
      }
    })
  }
  selectedTitle: any = []
  selectedTitleName: any = ""
  selectedTitleNameId: any = ""
  onTitleSelect(item: any) {
    this.selectedTitleName = '';
    this.selectedTitleNameId = '';
    this.selectedTitle.forEach(element => {
      this.selectedTitleName += element['itemName'] + ', ';
      this.selectedTitleNameId += element['id'] + ',';
    });
  }

  get f() {
    return this.registerForm.controls;
  }

  get f1() {
    return this.Generaltask.controls;
  }

  TaskStatus1: any = []
  TaskStatus() {
    let data = {}
    this.UserService.TaskStatus(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.TaskStatusArray = res
        this.TaskStatus1.push({
          'id': 1,
          'itemName': 'To-Do'
        })
      } else {
        this.TaskStatusArray = []
      }
    })
  }
  selectedStatus: any = []
  selectedStatusName: any = ""
  selectedStatusNameId: any = ""
  onStatusSelect(item: any, template: TemplateRef<any>) {
    this.selectedStatusName = item.itemName;
    this.selectedStatusNameId = '';
    this.selectedStatusNameId = item.id;
    if (item.itemName == 'Close' || item.itemName == 'Cancel') {
      this.popup = true;
      this.modalRef = this.modalService.show(template, { class: 'modal-sm modal-dialog-centered' });

    }
  }

  TaskPriority1: any = []
  TaskPriority() {
    let data = {}
    this.UserService.TaskPriority(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.TaskPriorityArray = res
        for (const data of this.TaskPriorityArray['Data']) {
          this.TaskPriority1.push({
            id: data['TaskPriorityId'],
            itemName: data['Name']
          });
        }
      } else {
        this.TaskPriorityArray = []
      }
    })
  }
  selectedPriority: any = []
  selectedPriorityName: any = ""
  selectedPriorityNameId: any = ""
  onPrioritySelect(item: any) {
    this.selectedPriorityName = '';
    this.selectedPriorityNameId = '';
    this.selectedPriorityNameId = item.id;
  }

  AssignedTo1: any = []
  AssignedTo() {
    let data = {}
    this.UserService.GetAllUser(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.AssignedToArray = res
        for (const data of this.AssignedToArray['Data']) {
          this.AssignedTo1.push({
            id: data['UserId'],
            itemName: `${data['UserName']} (${data['EmailId']}) ${data['EmployeeId']}`
          });
        }
      } else {
        this.AssignedToArray = []
      }
    })
  }
  selectedAssignedTo: any = []
  selectedAssignedToName: any = ""
  selectedAssignedTo1NameId: any = ""
  onAssignedToSelect(item: any) {
    this.selectedAssignedToName = '';
    this.selectedAssignedTo1NameId = '';
    this.selectedAssignedTo1NameId = item.id;
  }

  TaskFollowers1: any = []
  TaskFollowers() {
    let data = {}
    this.UserService.GetAllUser(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.TaskFollowersArray = res
        for (let i = 0; i < this.TaskFollowersArray['Data'].length; i++) {
          this.TaskFollowers1.push({
            'id': this.TaskFollowersArray['Data'][i]['UserId'],
            'itemName': this.TaskFollowersArray['Data'][i]['UserName'] + " (" + this.AssignedToArray['Data'][i]['EmailId'] + ") " + this.AssignedToArray['Data'][i]['EmployeeId']
          })
        }
      } else {
        this.TaskFollowersArray = []
      }
    })
  }
  selectedTaskFollowers: any = []
  selectedTaskFollowersName: any = ""
  selectedTaskFollowersNameId: any = ""
  onTaskFollowers(item: any) {
    this.selectedTaskFollowersName = '';
    this.selectedTaskFollowersNameId = '';
    this.selectedTaskFollowers.forEach(element => {
      this.selectedTaskFollowersName += element['itemName'] + ', ';
      this.selectedTaskFollowersNameId += element['id'] + ', ';
    });
  }

  Project1: any = []
  Project() {
    let data = {}
    this.UserService.GetAllProject(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.ProjectArray = res
        for (const data of this.ProjectArray['Data']) {
          this.Project1.push({
            id: data['ProjectId'],
            itemName: `${data['ProjectName']} (${data['ProjectNumber']})`,
            Status: data['Status']
          });
        }
      } else {
        this.ProjectArray = []
      }
    })
  }
  selectedProject: any = []
  selectedProjectName: any = ""
  selectedProjectNameId: any = ""
  onProject(item: any) {
    this.selectedProjectName = '';
    this.selectedProjectNameId = '';
    this.selectedstatus1NameId = '';
    this.selectedProjectNameId = item.id;
    this.selectedstatus1NameId = item.Status;
    this.InquiryList = [];
    this.selectedInquiry = [];
    this.getinquiirybyproject(this.selectedProjectNameId, this.selectedstatus1NameId)
  }

  InquiryArray: any = [];
  InquiryList: any = [];
  getinquiirybyproject(id, Status) {
    let data = {
      "ProjectId": id,
      "Status": Status
    }
    this.UserService.GetInqueryListByProjectId(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.InquiryArray = res;
        for (const data of this.InquiryArray['Data']) {
          this.InquiryList.push({
            id: data['InquiryId'],
            itemName: `${data['InquiryName']} (${data['InquiryNumber']})`
          });
        }
      } else {
        this.InquiryList = []
      }
    })
  }
  selectedInquiryName: any = ""
  selectedInquiryId: number = 0;
  onInquirySelect(item: any) {
    this.selectedInquiryName = '';
    this.selectedInquiryId = 0;
    this.selectedInquiry.forEach(element => {
      this.selectedInquiryName += element['itemName'];
      this.selectedInquiryId += element['id'];
    });
  }

  InquiryID1: any = []
  InquiryID() {
    let data = {}
    this.UserService.GetInqueryListByProjectId(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.TaskPriorityArray = res
        for (const data of this.TaskPriorityArray['Data']) {
          this.InquiryID1.push({
            id: data['TaskPriorityId'],
            itemName: data['Name']
          });
        }
      } else {
        this.TaskPriorityArray = []
      }
    })
  }

  TaskTitile3: any = []
  taskTitle2() {
    let data = {}
    this.UserService.TaskTitle(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.TaskTitileArray = res
        for (const data of this.TaskTitileArray['Data']) {
          this.TaskTitile3.push({
            id: data['TaskTitleId'],
            itemName: data['Name']
          });
        }
      } else {
        this.TaskTitileArray = []
      }
    })
  }
  selectedTitle2: any = []
  selectedTitleName2: any = ""
  selectedTitleNameId2: any = ""
  onTitleSelect2(item: any) {
    this.selectedTitleName2 = '';
    this.selectedTitleNameId2 = '';
    this.selectedTitle2.forEach(element => {
      this.selectedTitleName2 += element['itemName'] + ', ';
      this.selectedTitleNameId2 += element['id'] + ',';
    });
  }
  TaskStatus3: any = []
  TaskStatus2() {
    let data = {}
    this.UserService.TaskStatus(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.TaskStatusArray = res
        this.TaskStatus3.push({
          'id': 1,
          'itemName': 'To-Do'
        })
      } else {
        this.TaskStatusArray = []
      }
    })
  }
  selectedStatus2: any = []
  selectedStatusName2: any = ""
  selectedStatusNameId2: any = ""
  onStatusSelect2(item: any) {
    this.selectedStatusName2 = '';
    this.selectedStatusNameId2 = '';
    this.selectedStatusNameId2 = item.id;
  }
  TaskPriority3: any = []
  TaskPriority2() {
    let data = {}
    this.UserService.TaskPriority(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.TaskPriorityArray = res
        for (const data of this.TaskPriorityArray['Data']) {
          this.TaskPriority3.push({
            id: data['TaskPriorityId'],
            itemName: data['Name']
          });
        }
      } else {
        this.TaskPriorityArray = []
      }
    })
  }
  selectedPriority2: any = []
  selectedPriorityName2: any = ""
  selectedPriorityNameId2: any = ""
  onPrioritySelect2(item: any) {
    this.selectedPriorityName2 = '';
    this.selectedPriorityNameId2 = '';
    this.selectedPriorityNameId2 = item.id;
  }
  AssignedTo3: any = []
  AssignedTo2() {
    let data = {}
    this.UserService.GetAllUser(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.AssignedToArray = res
        for (const data of this.AssignedToArray['Data']) {
          this.AssignedTo3.push({
            id: data['UserId'],
            itemName: `${data['UserName']} (${data['EmailId']}) ${data['EmployeeId']}`
          });
        }
      } else {
        this.AssignedToArray = []
      }
    })
  }
  selectedAssignedTo2: any = []
  selectedAssignedToName2: any = ""
  selectedAssignedTo1NameId2: any = ""
  onAssignedToSelect2(item: any) {
    this.selectedAssignedToName2 = '';
    this.selectedAssignedTo1NameId2 = '';
    this.selectedAssignedTo1NameId2 = item.id;
  }
  TaskFollowers3: any = []
  TaskFollowers2() {
    let data = {}
    this.UserService.GetAllUser(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.TaskFollowersArray = res
        for (let i = 0; i < this.TaskFollowersArray['Data'].length; i++) {
          this.TaskFollowers3.push({
            'id': this.TaskFollowersArray['Data'][i]['UserId'],
            'itemName': this.TaskFollowersArray['Data'][i]['UserName'] + " (" + this.AssignedToArray['Data'][i]['EmailId'] + ") " + this.AssignedToArray['Data'][i]['EmployeeId']
          })
        }
      } else {
        this.TaskFollowersArray = []
      }
    })
  }
  selectedTaskFollowers2: any = []
  selectedTaskFollowersName2: any = ""
  selectedTaskFollowersNameId2: any = ""
  onTaskFollowers2(item: any) {
    this.selectedTaskFollowersName2 = '';
    this.selectedTaskFollowersNameId2 = '';
    this.selectedTitle.forEach(element => {
      this.selectedTaskFollowersName2 += element['itemName'] + ', ';
      this.selectedTaskFollowersNameId2 += element['id'] + ', ';
    });
  }

  changeActivityType(type) {
    this.activitytype = type;
  }
  
  onSubmit() {
    if (this.registerForm.value.Start_Date && this.registerForm.value.Start_Date != '') {
      this.Start_Date = this.datePipe.transform(this.registerForm.value.Start_Date, "yyyy-MM-dd");
    }
    if (this.registerForm.value.End_Date && this.registerForm.value.End_Date != '') {
      this.End_Date = this.datePipe.transform(this.registerForm.value.End_Date, "yyyy-MM-dd");
    }
    if (this.Start_Date > this.End_Date) {

      this.invaliddate = true;
      return;
    }
    else {
      this.invaliddate = false;
    }
    if (this.Generaltask.value.Start_Date2 && this.Generaltask.value.Start_Date2 != '') {
      this.Start_Date2 = this.datePipe.transform(this.Generaltask.value.Start_Date2, "yyyy-MM-dd");
    }
    if (this.Generaltask.value.End_Date2 && this.Generaltask.value.End_Date2 != '') {
      this.End_Date2 = this.datePipe.transform(this.Generaltask.value.End_Date2, "yyyy-MM-dd");
    }
    this.submitted = true;
    if (this.activitytype == 'activity') {
      let data = {
        "ProjectId": this.selectedProjectNameId,
        "InquiryId": this.selectedInquiryId,
        "Tasktitle": this.selectedTitleNameId,
        "TaskStatus": this.selectedStatusNameId,
        "AssignedTo": this.selectedAssignedTo1NameId,
        "TaskFollowers": this.selectedTaskFollowersNameId,
        "TaskPriority": this.selectedPriorityNameId,
        "StartDate": this.Start_Date,
        "EndDate": this.End_Date,
        "TaskDescription": this.registerForm.value.Task_Description,
        "Remark": this.registerForm.value.Remark_,
        "ActionTaken": this.registerForm.value.ActionTaken_,
        "OutComeRemark": this.registerForm.value.OutcomeRemark_,
      }
      if (this.registerForm.valid) {
        this.spinner.show();
        this.UserService.AddUpdateTask(data).subscribe(res => {
          if (res['result'] == 'success') {
            this.spinner.hide();
            this.toastr.success(res['Msg']);
            this.ngOnInit()
            this.router.navigate(['/Task/TaskList']);
          } else if (res['result'] == 'Failed') {
            this.toastr.error(res['Msg']);
            this.spinner.hide();
          } else {
            this.toastr.error(res['Message']);
            this.spinner.hide();
          }
          this.submitted = false;
        })
      }
    }
    else {
      let data1 = {
        "Tasktitle": this.selectedTitleNameId2,
        "TaskStatus": this.selectedStatusNameId2,
        "AssignedTo": this.selectedAssignedTo1NameId2,
        "TaskPriority": this.selectedPriorityNameId2,
        "StartDate": this.Start_Date2,
        "EndDate": this.End_Date2,
        "TaskDescription": this.Generaltask.value.Task_Description2,
        "Remark": this.Generaltask.value.Remark_2,
        "ActionTaken": this.Generaltask.value.ActionTaken_2,
        "OutComeRemark": this.Generaltask.value.OutcomeRemark_2,
      }
      if (this.Generaltask.valid) {
        this.spinner.show();
        this.UserService.AddUpdateTask(data1).subscribe(res => {
          if (res['result'] == 'success') {
            this.spinner.hide();
            this.toastr.success(res['Msg']);
            this.ngOnInit()
            this.router.navigate(['/Task/TaskList']);
          } else if (res['result'] == 'Failed') {
            this.toastr.error(res['Msg']);
            this.spinner.hide();
          } else {
            this.toastr.error(res['Message']);
            this.spinner.hide();
          }
          this.submitted = false;
        })
      }
    }
  }

  deleteOpenModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm modal-dialog-centered' });
  }

  deleteConfirm() {
    this.popup = false;
    this.modalRef.hide();
  }

  decline() {
    this.registerForm.get('Task_Status').setValue('');
    this.modalRef.hide();
  }

  decline1() {
    this.modalRef.hide();
  }

  newFunc(event: any) {
    this.maxEndDate = new Date(event);
  }

  newFunc2(event: any) {
    this.maxStartDate = new Date(event);
  }

}

